import React from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { useLocation, Navigate } from 'react-router-dom';

export const RequiredAuth = ({ children }) => {
  const { oktaAuth, authState } = useOktaAuth();
  const location = useLocation();

  if (!authState) {
    // Auth state is not yet loaded
    return <div>Loading authentication...</div>;
  }

  if (!authState.isAuthenticated) {
    // User is not authenticated, redirect to login
    // We store the original URI so we can redirect back after login
    oktaAuth.setOriginalUri(location.pathname);
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default RequiredAuth;